import { useEffect, useState, useRef } from "react";
import "./App.css";
import SingleCard from "./components/SingleCard";

const cardImages = [
  { src: "/img/alessio.jpg", matched: false },
  { src: "/img/carmen.jpg", matched: false },
  { src: "/img/delia.jpg", matched: false },
  { src: "/img/fede.jpg", matched: false },
  { src: "/img/ing.jpg", matched: false },
  { src: "/img/lara.jpg", matched: false },
  { src: "/img/pit.jpg", matched: false },
  { src: "/img/tratzi.jpg", matched: false },
  { src: "/img/vale.jpg", matched: false },
  { src: "/img/max.jpg", matched: false }
];

function App() {
  const [cards, setCards] = useState([]);
  const [turns, setTurns] = useState(0);
  const [choiceOne, setChoiceOne] = useState(null);
  const [choiceTwo, setChoiceTwo] = useState(null);
  const [disabled, setDisabled] = useState(false);

  const audioRef = useRef(null);
  const currentYear = new Date().getFullYear();

  //shuffle cards
  const shuffleCards = () => {
    audioRef.current.play();
    const shuffledCards = [...cardImages, ...cardImages]
      .sort(() => Math.random() - 0.5)
      .map(card => ({ ...card, id: Math.random() }));
    setChoiceOne(null);
    setChoiceTwo(null);
    setCards(shuffledCards);
    setTurns(0);
  };

  //handle a choice
  const handleChoice = card => {
    choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
  };

  //compare two selected cards
  useEffect(() => {
    if (choiceOne && choiceTwo) {
      setDisabled(true);
      if (choiceOne.src === choiceTwo.src) {
        setCards(prevCards => {
          return prevCards.map(card => {
            if (card.src === choiceOne.src) {
              return { ...card, matched: true };
            } else {
              return card;
            }
          });
        });
        resetTurn();
      } else {
        setTimeout(() => resetTurn(), 1000);
      }
    }
  }, [choiceOne, choiceTwo]);

  //reset choice & count a new turn
  const resetTurn = () => {
    setChoiceOne(null);
    setChoiceTwo(null);
    setTurns(prevTurns => prevTurns + 1);
    setDisabled(false);
  };

  return (
    <div className="App">
      <div className="main">
        <h1>DettoFatto Memory</h1>
        <audio ref={audioRef} src="/audio/start.mp3"></audio>
        <button onClick={shuffleCards}>New Game</button>
        <div className="card-grid">
          {cards.map(card => (
            <SingleCard
              key={card.id}
              card={card}
              handleChoice={handleChoice}
              flipped={card === choiceOne || card === choiceTwo || card.matched}
              disabled={disabled}
            />
          ))}
        </div>
        <p>Turns: {turns} </p>
        <p className="copyright">© {currentYear} made with 🧡 by Andrea Bruno</p>
      </div>
    </div>
  );
}

export default App;
